module.exports = __webpack_public_path__ + "static/media/fifth_north_church4.3a7bc763.jpg";